import { cloneElement, useState, useImperativeHandle, forwardRef } from "react";
import PropTypes from "prop-types";
import { StickyNote } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import NoteForm from "components/forms/NoteForm";
import { useActivityCategories } from "hooks/useActivityCategories";

const NewNoteModal = forwardRef(
  (
    {
      modelType,
      modelId,
      onSuccess = () => {},
      refersToModel,
      refersToID,
      trigger = (
        <Button size="sm" className="item-adder">
          <StickyNote />
          Add Note
        </Button>
      ),
      noTrigger = false,
    },
    ref
  ) => {
    const [open, setOpen] = useState(false);
    const { categories, refetchCategories } = useActivityCategories();

    useImperativeHandle(ref, () => ({
      open: () => setOpen(true),
    }));

    const handleSuccess = async () => {
      await onSuccess();
      setOpen(false);
    };

    return (
      <>
        {!noTrigger && cloneElement(trigger, { onClick: () => setOpen(true) })}
        <Dialog open={open} onOpenChange={setOpen} disablePointerDismissal>
          <DialogContent className="tw:sm:max-w-5xl">
            <DialogTitle>New Note</DialogTitle>
            <NoteForm
              modelType={modelType}
              modelId={modelId}
              categories={categories}
              updateCategories={refetchCategories}
              onSuccess={handleSuccess}
              refersToModel={refersToModel}
              refersToID={refersToID}
            />
          </DialogContent>
        </Dialog>
      </>
    );
  }
);

NewNoteModal.displayName = "NewNoteModal";

NewNoteModal.propTypes = {
  modelType: PropTypes.string,
  modelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSuccess: PropTypes.func,
  refersToModel: PropTypes.string,
  refersToID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  trigger: PropTypes.element,
  noTrigger: PropTypes.bool,
};

export { NewNoteModal };
